var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.625 9.00195H30.75V7.75195C30.75 5.68422 29.0677 4.00195 27 4.00195H22C19.9323 4.00195 18.25 5.68422 18.25 7.75195V9.00195H11.375C9.65188 9.00195 8.25 10.4038 8.25 12.127V16.502C8.25 17.1923 8.80969 17.752 9.5 17.752H10.1831L11.263 40.4303C11.3584 42.4331 13.0037 44.002 15.0087 44.002H33.9913C35.9963 44.002 37.6416 42.4331 37.737 40.4303L38.8169 17.752H39.5C40.1903 17.752 40.75 17.1923 40.75 16.502V12.127C40.75 10.4038 39.3481 9.00195 37.625 9.00195ZM20.75 7.75195C20.75 7.06273 21.3108 6.50195 22 6.50195H27C27.6892 6.50195 28.25 7.06273 28.25 7.75195V9.00195H20.75V7.75195ZM10.75 12.127C10.75 11.7823 11.0304 11.502 11.375 11.502H37.625C37.9696 11.502 38.25 11.7823 38.25 12.127V15.252C37.8648 15.252 12.3463 15.252 10.75 15.252V12.127ZM35.2398 40.3114C35.208 40.979 34.6595 41.502 33.9913 41.502H15.0087C14.3404 41.502 13.792 40.979 13.7602 40.3114L12.6859 17.752H36.3141L35.2398 40.3114Z",
    fill: "#39695B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 39.002C25.1903 39.002 25.75 38.4423 25.75 37.752V21.502C25.75 20.8116 25.1903 20.252 24.5 20.252C23.8097 20.252 23.25 20.8116 23.25 21.502V37.752C23.25 38.4423 23.8096 39.002 24.5 39.002Z",
    fill: "#39695B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.75 39.002C31.4403 39.002 32 38.4423 32 37.752V21.502C32 20.8116 31.4403 20.252 30.75 20.252C30.0597 20.252 29.5 20.8116 29.5 21.502V37.752C29.5 38.4423 30.0596 39.002 30.75 39.002Z",
    fill: "#39695B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 39.002C18.9403 39.002 19.5 38.4423 19.5 37.752V21.502C19.5 20.8116 18.9403 20.252 18.25 20.252C17.5597 20.252 17 20.8116 17 21.502V37.752C17 38.4423 17.5596 39.002 18.25 39.002Z",
    fill: "#39695B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelGreen);
export default __webpack_public_path__ + "static/media/del-green.5a86d1bd1c8ae7e7dbaec894435587c4.svg";
export { ForwardRef as ReactComponent };